import { render, staticRenderFns } from "./IpBundleDtlsList.vue?vue&type=template&id=273ea764&scoped=true&"
import script from "./IpBundleDtlsList.vue?vue&type=script&lang=js&"
export * from "./IpBundleDtlsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ea764",
  null
  
)

export default component.exports